import script from "./Marquee.vue?vue&type=script&setup=true&lang=js"
export * from "./Marquee.vue?vue&type=script&setup=true&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=36b7670c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b7670c"]])

export default __exports__